import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import LoadingContext from "./context/loadingcontext";
import AuthContextProvider from "./context/AuthContext";
import { SnackbarProvider } from "./components/SnackbarProvider";
import { PDFProvider } from "./context/pdfContext";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <PDFProvider>
        <LoadingContext>
          <SnackbarProvider>
            <AuthContextProvider>
              <App />
            </AuthContextProvider>
          </SnackbarProvider>
        </LoadingContext>
      </PDFProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
